import {
  COJG_CASE_NOTE_ADD_NEW,
  COJG_CASE_NOTE_ADD_NEW_SUCCESS,
  COJG_CASE_NOTE_ADD_NEW_ERROR,
  COJG_CASE_NOTE_DELETE,
  COJG_CASE_NOTE_DELETE_ERROR,
  COJG_CASE_NOTE_DELETE_SUCCESS,
  COJG_CASE_NOTE_EDIT,
  COJG_CASE_NOTE_EDIT_ERROR,
  COJG_CASE_NOTE_EDIT_SUCCESS,
  COJG_CASE_NOTE_GET_BY_ID,
  COJG_CASE_NOTE_GET_BY_ID_ERROR,
  COJG_CASE_NOTE_GET_BY_ID_SUCCESS,
  COJG_CASE_NOTE_GET_LIST,
  COJG_CASE_NOTE_GET_LIST_ERROR,
  COJG_CASE_NOTE_GET_LIST_SUCCESS,
  COJG_CASE_NOTE_ADD_NEW_REQUEST,
  COJG_CASE_NOTE_QUERY,
  COJG_CASE_NOTE_QUERY_SUCCESS,
  COJG_CASE_NOTE_QUERY_ERROR,
} from '../actions';

const initialState = {
  caseNotes: [],
  caseNote: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case COJG_CASE_NOTE_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case COJG_CASE_NOTE_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNote: payload,
      };

    case COJG_CASE_NOTE_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case COJG_CASE_NOTE_QUERY:
    case COJG_CASE_NOTE_GET_LIST:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case COJG_CASE_NOTE_QUERY_SUCCESS:
    case COJG_CASE_NOTE_GET_LIST_SUCCESS:
      return {
        ...state,
        caseNotes: payload,
        loading: true,
      };
    case COJG_CASE_NOTE_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case COJG_CASE_NOTE_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNote: payload,
        caseNotes: state.caseNotes.concat(payload),
        addSuccess: true,
      };

    case COJG_CASE_NOTE_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case COJG_CASE_NOTE_EDIT_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNotes: state.caseNotes.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        caseNote: payload,
        error: null,
        editSuccess: true,
      };
    case COJG_CASE_NOTE_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case COJG_CASE_NOTE_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNotes: state.caseNotes.filter(c => c.id !== payload),
        deleteSuccess: true,
      };
    case COJG_CASE_NOTE_QUERY_ERROR:
    case COJG_CASE_NOTE_DELETE_ERROR:
    case COJG_CASE_NOTE_ADD_NEW_ERROR:
    case COJG_CASE_NOTE_EDIT_ERROR:
    case COJG_CASE_NOTE_GET_BY_ID_ERROR:
    case COJG_CASE_NOTE_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
